import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06fb6aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account__tab tab--1 is-open" }
const _hoisted_2 = { class: "row row--account" }
const _hoisted_3 = { class: "col-12 col-xl-6" }
const _hoisted_4 = { class: "account__title" }
const _hoisted_5 = { class: "row form__field app-disabled" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form__label required" }
const _hoisted_8 = { class: "row form__field" }
const _hoisted_9 = { class: "form__label required" }
const _hoisted_10 = { class: "row form__field" }
const _hoisted_11 = { class: "form__label required" }
const _hoisted_12 = { class: "row form__field app-disabled" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form__label required" }, "E-mail", -1))
const _hoisted_15 = { class: "row form__field" }
const _hoisted_16 = { class: "col form__col select__col" }
const _hoisted_17 = { class: "select__label required" }
const _hoisted_18 = { class: "row form__field" }
const _hoisted_19 = { class: "col form__col select__col" }
const _hoisted_20 = { class: "select__label required" }
const _hoisted_21 = { class: "row form__field" }
const _hoisted_22 = { class: "col form__col select__col" }
const _hoisted_23 = { class: "select" }
const _hoisted_24 = { class: "select__label required" }
const _hoisted_25 = { class: "row form__field" }
const _hoisted_26 = {
  style: {"display":"flex","align-items":"center"},
  class: "d-flex flex-row checkbox"
}
const _hoisted_27 = {
  for: "marketing_subscription",
  class: "required",
  style: {"padding-left":"10px"}
}
const _hoisted_28 = { class: "row form__field" }
const _hoisted_29 = {
  style: {"display":"flex","align-items":"center"},
  class: "d-flex flex-row checkbox"
}
const _hoisted_30 = {
  for: "marketing_on_company_profile",
  class: "required",
  style: {"padding-left":"10px"}
}
const _hoisted_31 = { class: "row form__field app-disabled" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "form__label required" }
const _hoisted_34 = { class: "col-12 col-xl-6" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "account__title" }
const _hoisted_37 = { class: "phone-head" }
const _hoisted_38 = { class: "account__title" }
const _hoisted_39 = { role: "row" }
const _hoisted_40 = {
  class: "text-left",
  "aria-sort": "none"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon",
  width: "12",
  height: "12"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#plus" })
], -1))
const _hoisted_42 = { class: "col form__col form__group--active phone-block" }
const _hoisted_43 = { class: "account__phone-type required" }
const _hoisted_44 = {
  key: 0,
  class: "select"
}
const _hoisted_45 = ["value"]
const _hoisted_46 = {
  key: 1,
  class: "select"
}
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "account__actions" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#edit" }, null, -1))
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 1,
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#check-circle2" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = {
  key: 2,
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#check-circle2" }, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { key: 0 }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#icon-delete" })
], -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon dashboard__table-icon",
  width: "18",
  height: "18"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#decline" })
], -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = { class: "row form__field" }
const _hoisted_68 = { class: "col form__col btn__col" }
const _hoisted_69 = {
  class: "button",
  type: "submit"
}
const _hoisted_70 = {
  key: 0,
  style: {"margin-left":"10px","margin-top":"1px","position":"absolute"},
  class: "p-button-loading-icon pi pi-spinner pi-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!
  const _component_p_calendar = _resolveComponent("p-calendar")!
  const _component_app_account_manager = _resolveComponent("app-account-manager")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "account__form",
      onSubmit: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.generalInfo" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active': _ctx.idFocused || _ctx.userDto?.id,
                            }])
            }, [
              _createElementVNode("input", {
                class: "form__input",
                value: _ctx.userDto?.id,
                tabindex: "-1"
              }, null, 8, _hoisted_6),
              _createElementVNode("label", _hoisted_7, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.userid" })
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active':
                                    _ctx.firstnameFocused || _ctx.form.values.firstname,
                            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form__input", { '--error': _ctx.form.errors.firstname }]),
                name: "firstname",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.values.firstname) = $event)),
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.firstnameFocused = true)),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.firstnameFocused = false))
              }, null, 34), [
                [_vModelText, _ctx.form.values.firstname]
              ]),
              _createElementVNode("label", _hoisted_9, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.fname" })
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active':
                                    _ctx.lastnameFocused || _ctx.form.values.lastname,
                            }])
            }, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form__input", { '--error': _ctx.form.errors.lastname }]),
                name: "lastname",
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.lastnameFocused = true)),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.lastnameFocused = false)),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.values.lastname) = $event))
              }, null, 34), [
                [_vModelText, _ctx.form.values.lastname]
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.lname" })
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active': _ctx.emailFocused || _ctx.userDto?.email,
                            }])
            }, [
              _createElementVNode("input", {
                class: "form__input",
                value: _ctx.userDto?.email,
                tabindex: "-1"
              }, null, 8, _hoisted_13),
              _hoisted_14
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: _normalizeClass(["select", { '--error': _ctx.form.errors.id_language }])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.language" })
                ]),
                _createVNode(_component_app_dropdown, {
                  modelValue: _ctx.form.values.id_language,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.values.id_language) = $event)),
                  onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.languageFocused = true)),
                  onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.languageFocused = false)),
                  name: "language",
                  placeholder: _ctx.i18n.t('common.subjectPlaceholder'),
                  type: 'single',
                  "get-label": (language) => language.name,
                  "get-value": (language) => language.id,
                  options: _ctx.languageOptions,
                  showCheckbox: false
                }, null, 8, ["modelValue", "placeholder", "get-label", "get-value", "options"])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["select", { '--error': _ctx.form.errors.id_gender }])
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.gender" })
                ]),
                _createVNode(_component_app_dropdown, {
                  modelValue: _ctx.form.values.id_gender,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.values.id_gender) = $event)),
                  onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.genderFocused = true)),
                  onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.genderFocused = false)),
                  name: "gender",
                  placeholder: _ctx.i18n.t('common.subjectPlaceholder'),
                  type: 'single',
                  "get-label": (gender) => gender.name,
                  "get-value": (gender) => gender.id,
                  options: _ctx.genderOptions,
                  showCheckbox: false
                }, null, 8, ["modelValue", "placeholder", "get-label", "get-value", "options"])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.dateOfBirth" })
                ])
              ]),
              _createVNode(_component_p_calendar, {
                modelValue: _ctx.form.values.date_of_birth,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.values.date_of_birth) = $event)),
                placeholder: 'dd/mm/yyyy',
                id: "date_of_birth",
                selectionMode: "single",
                manualInput: true,
                dateFormat: 'dd/mm/yy',
                onInput: _ctx.onKeyDate
              }, null, 8, ["modelValue", "onInput"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                id: "marketing_subscription",
                type: "checkbox",
                name: "marketing_subscription",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.values.marketing_subscription) = $event)),
                onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.marketingSubscriptionFocused = true)),
                onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.marketingSubscriptionFocused = false)),
                class: _normalizeClass({ '--error': _ctx.form.errors.marketing_subscription })
              }, null, 34), [
                [_vModelCheckbox, _ctx.form.values.marketing_subscription]
              ]),
              _createElementVNode("label", _hoisted_27, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.marketingSubscription" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                id: "marketing_on_company_profile",
                type: "checkbox",
                name: "marketing_on_company_profile",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.values.marketing_on_company_profile) = $event)),
                onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.marketingOnCompanyProfileFocused = true)),
                onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.marketingOnCompanyProfileFocused = false)),
                class: _normalizeClass({ '--error': _ctx.form.errors.marketing_on_company_profile })
              }, null, 34), [
                [_vModelCheckbox, _ctx.form.values.marketing_on_company_profile]
              ]),
              _createElementVNode("label", _hoisted_30, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.marketingOnCompanyProfile" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              class: _normalizeClass(["col form__col", {
                                'form__group--active': _ctx.roleFocused || _ctx.userDto?.role.id,
                            }])
            }, [
              _createElementVNode("input", {
                class: "form__input",
                value: _ctx.userDto?.role.name,
                tabindex: "-1"
              }, null, 8, _hoisted_32),
              _createElementVNode("label", _hoisted_33, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.role" })
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          (!_ctx.shouldHideContactInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("h5", _hoisted_36, [
                  _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.managerTitle" })
                ]),
                _createVNode(_component_app_account_manager)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h5", _hoisted_38, [
              _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.contactInfoTab.phones" })
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _withDirectives((_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["js-add-location dashboard__add-location", { 'is-disabled': _ctx.isViewer }]),
                    onClick: _cache[19] || (_cache[19] = () => _ctx.createPhoneNumberRow())
                  }, [
                    _hoisted_41,
                    _createElementVNode("span", null, [
                      _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.companyInfoTab.addPhoneNumber" })
                    ])
                  ], 2)
                ])), [
                  [_directive_tippy, {
                                        content: _ctx.isViewer
                                            ? _ctx.i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }]
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneNumbers, (phoneNumber) => {
            return (_openBlock(), _createElementBlock("div", {
              key: String(phoneNumber.id),
              role: "row",
              class: _normalizeClass(["row form__field account__form", { 'app-disabled': _ctx.isViewer }])
            }, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", null, [
                    (phoneNumber.edit && phoneNumber.id == null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          (phoneNumber.id === null)
                            ? (_openBlock(), _createBlock(_component_app_dropdown, {
                                key: 0,
                                modelValue: phoneNumber.type,
                                "onUpdate:modelValue": ($event: any) => ((phoneNumber.type) = $event),
                                onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.phoneNumberTypeFocused = true)),
                                onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.phoneNumberTypeFocused = false)),
                                name: "phoneType",
                                placeholder: phoneNumber?.type?.name || '',
                                type: 'single',
                                "get-label": (phoneType) => phoneType.name,
                                "get-value": (phoneType) => phoneType.id,
                                options: _ctx.phoneNumberType,
                                showCheckbox: false
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "get-label", "get-value", "options"]))
                            : (_openBlock(), _createElementBlock("input", {
                                key: 1,
                                class: "form__input",
                                name: "lastname",
                                value: phoneNumber.type?.name || '',
                                disabled: ""
                              }, null, 8, _hoisted_45))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("span", null, _toDisplayString(phoneNumber?.type?.name), 1)
                        ]))
                  ])
                ]),
                (phoneNumber.edit)
                  ? (_openBlock(), _createBlock(_component_vue_tel_input, _mergeProps({
                      key: 0,
                      modelValue: phoneNumber.number,
                      "onUpdate:modelValue": ($event: any) => ((phoneNumber.number) = $event)
                    }, _ctx.phoneProps(phoneNumber.number), {
                      onValidate: 
                                    (phoneObject) =>
                                        _ctx.validatePhone(phoneObject, phoneNumber.number)
                                ,
                      onInput: _ctx.validateInput,
                      onFocus: ($event: any) => (_ctx.handleFocus(phoneNumber.number)),
                      inputOptions: { readonly: !phoneNumber.edit }
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate", "onInput", "onFocus", "inputOptions"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("span", null, _toDisplayString(phoneNumber.number), 1)
                    ])),
                _createElementVNode("div", _hoisted_48, [
                  _withDirectives((_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["dashboard__table-link", { 'is-disabled': _ctx.isViewer }]),
                      href: "#",
                      title: "Update",
                      onClick: () => _ctx.uploadPhone(phoneNumber)
                    }, [
                      (
                                                !phoneNumber.edit &&
                                                phoneNumber.id !== null
                                            )
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_50, _hoisted_52))
                        : _createCommentVNode("", true),
                      (
                                                phoneNumber.edit &&
                                                phoneNumber.phoneNumberIsValid &&
                                                phoneNumber.id !== null
                                            )
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_53, _hoisted_55))
                        : _createCommentVNode("", true),
                      (
                                                phoneNumber.phoneNumberIsValid &&
                                                phoneNumber.id === null &&
                                                phoneNumber.type !== null
                                            )
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_58))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_49)
                  ])), [
                    [_directive_tippy, {
                                        content: _ctx.isViewer
                                            ? _ctx.i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }]
                  ]),
                  (phoneNumber.id !== null)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("a", {
                          class: _normalizeClass([{ 'is-disabled': _ctx.isViewer }, "dashboard__table-link dashboard__table-link_warning"]),
                          href: "#",
                          title: "Delete",
                          onClick: () => _ctx.deletePhone(phoneNumber)
                        }, _hoisted_62, 10, _hoisted_60)
                      ])), [
                        [_directive_tippy, {
                                        content: _ctx.isViewer
                                            ? _ctx.i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }]
                      ])
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "dashboard__table-link dashboard__table-link_warning",
                        href: "#",
                        title: "Cancel",
                        onClick: () => _ctx.deletePhone(phoneNumber)
                      }, _hoisted_65, 8, _hoisted_63))
                ])
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", _hoisted_69, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.myAccountComponent.saveBtn" }),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_70))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ], 32)
  ]))
}